module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-scale-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "tooltip",
    staticClass: "tooltip-message"
  }, [_c('v-card', {
    style: ({
      background: _vm.$store.getters.isDarkTheme ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.6)'
    })
  }, [_c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.tooltipMessage)
    }
  })])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54d8df51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/utils/shared-components/overlay-feature.vue
// module id = 1064
// module chunks = 1